/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import cx from 'classnames';
import { forwardRef, memo } from 'react';

import { useComponentContext } from './BoxPicker.context';
import { createBoxPickerStyle } from './BoxPicker.styles';

type BoxPickerItemProps = {
  value: any;
  children: React.ReactNode;
  className?: string;
  notActiveClassName?: string;
  disabled?: boolean;
  id?: string;
};

export const BoxPickerItem = memo(
  forwardRef<HTMLDivElement, BoxPickerItemProps>((props, ref) => {
    const { children, value, className = '', disabled, notActiveClassName = '', id, ...otherProps } = props;
    const { onItemChange, isActive } = useComponentContext();
    const classes = createBoxPickerStyle();

    const active = isActive(value);

    return (
      <div
        {...otherProps}
        ref={ref}
        className={cx({
          [classes.default]: true,
          [classes.focus]: !disabled,
          [classes.isActive]: !disabled && active,
          [className]: className,
          [notActiveClassName]: !active && notActiveClassName,
        })}
        onClick={disabled ? undefined : () => onItemChange(value)}
        tabIndex={0} // eslint-disable-line
        id={id}
      >
        {children}
      </div>
    );
  }),
);
